export default __webpack_public_path__ + "static/form-thank-you-smiley--mobile-033de4a4e9d92a0779f125a5cc65fdd0.png";